/**
=========================================================
* Material Dashboard 2 PRO React TS - v1.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-2-pro-react-ts
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Material Dashboard 2 PRO React TS Base Styles
import colors from "../../base/colors";
import borders from "../../base/borders";
import boxShadows from "../../base/boxShadows";
import rgba from "../../functions/rgba";

const { borderRadius, borderWidth } = borders;
const { background, white, black } = colors;
const { md } = boxShadows;

// types
type Types = any;

const accordion: Types = {
  styleOverrides: {
    root: {
      boxShadow: md,
      backgroundColor: background.card,
      color: white.main,
      "&:before": {
        backgroundColor: `${rgba(black.main, 1)}`,
      },
      "& .MuiListItem-root": {
        borderColor: `${rgba(black.main, 1)}`
      },
      "& .MuiListItem-root.field-drag-item-added": {
        backgroundColor: `${rgba(black.main, 1)}`
      }
    },
  },
};

export default accordion;
